import React, { useState } from 'react'
import { Box, Breadcrumbs, Link, Paper, Typography, Button, LinearProgress, linearProgressClasses, CircularProgress, CircularProgressProps, circularProgressClasses, Card, Container, TooltipProps, tooltipClasses, Tooltip, FormGroup, Stack, Switch } from '@mui/material';
import Grid from '@mui/material/Grid2';
import styled from '@emotion/styled';
import { communication, file, hubspot, humanResource, personAdd, salesForceImg, girlWithLaptop, mostPopular } from '../../../../assets/images';
import { GroupIcon, LaunchIcon, PauseIcon, PlayIcon, CommunicationIcon, DatabaseIcon, InformationIcon } from '../../../../assets/icons';
import CancelAccountModal from '../../../modals/CancelAccount';
import CancelSubscription from '../../../modals/CancelSubscription';


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 18,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#DDE0E5",
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 16,
        backgroundColor: '#614EFA',
    },
}));

const BorderLinearProgressGreen = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 18,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#DDE0E5",
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 16,
        backgroundColor: '#22B060',
    },
}));

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "#2B2B30",
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#2B2B30",
    },
}));

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(18px)',
            top: "2px"
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        top: "2px",
        left: "2px",
        '&.Mui-checked': {
            transform: 'translateX(17px)',
            color: '#fff',
            top: "2px",
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#22B060',
                // ...theme.applyStyles('dark', {
                //     backgroundColor: '#177ddc',
                // }),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 18,
        height: 18,
        borderRadius: 18,
        transition: "200ms ease all",
    },
    '& .MuiSwitch-track': {
        borderRadius: 18,
        opacity: 1,
        backgroundColor: '#22B060',
        boxSizing: 'border-box',
        // ...theme.applyStyles('dark', {
        //     backgroundColor: 'rgba(255,255,255,.35)',
        // }),
    },
}));

const SubscriptionDetails = ({ navigate }: any) => {
    function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    const [renewelPaused, setRenewelPaused] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isCancelModalOpen, setCancelModal] = useState(false);


    const handleOpen = () => {
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
    };


    const handleCancelOpen = () => {
        setCancelModal(true);
    };

    const handleCancelClose = () => {
        setCancelModal(false);
    };


    return (
        <Container sx={{ maxWidth: "1500px !important", px: '0!important' }}>
            <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="subsciption details breadcrumb" sx={{
                    color: "#614EFA", fontSize: "14px", paddingTop: "0 !important", "& li:last-child a": { color: "#000000" }
                }}>
                    <Link underline="hover" color="#614EFA" href="/" onClick={() => {
                        navigate('/subscription');
                    }}>
                        Subscriptions
                    </Link>
                    <Link
                        underline="hover"
                        href="#"
                    >
                        Easywebinar
                    </Link>
                </Breadcrumbs>
            </div>
            <Box mt={"18px"} display={"flex"} alignItems={"center"}>
                <Typography variant="h2" color="initial" display={"inline"} fontSize={"34px"} fontWeight={"500"}>Standard plan</Typography><Box display={"inline-flex"} width={"fit-content"} p={"3px 12px"} borderRadius={"10px"} bgcolor={"rgba(97, 78, 250, 0.10)"} color={"#614EFA"} ml={3} fontSize={"16px"} fontWeight={"500"}>Active</Box>
            </Box>

            <Paper sx={{
                p: "24px", mt: "39px", borderRadius: "8px",
                border: "1px solid #E8EAF0", boxShadow: "none"
            }}>
                <Box display={"flex"} justifyContent={"space-between"} flexWrap={"wrap"} gap={"16px"}>
                    <Box>
                        <Typography variant="body2" color="#333333">Plan Details</Typography>
                        <Typography variant="h5" color="initial" fontWeight={"500"} mt={1}>Standard Plan</Typography>
                    </Box>
                    <Button sx={{
                        textTransform: 'capitalize', bgcolor: '#22B060 !important', color: '#FFFFFF !important', px: '24px', height: '40px', borderRadius: '8px', '&:hover': {
                            border: 'none', boxShadow: 'none !important'
                        },
                    }}>Upgrade Plan</Button>
                </Box>
                <Box display={"flex"} mt="32px" flexWrap={"wrap"}>
                    <Box minWidth={"184px"} width={"17%"} margin={{ xs: "0 0 24px", sm: "" }}>
                        <Typography variant="body2" color="#333333">Start Date</Typography>
                        <Typography variant="h6" color="initial" fontWeight={"500"} mt={1}>11 Oct, 2024</Typography>
                    </Box>
                    <Box minWidth={"184px"} width={"17%"} margin={{ xs: "0 0 24px", sm: "" }}>
                        <Typography variant="body2" color="#333333">Next Billing Date</Typography>
                        <Typography variant="h6" color="initial" fontWeight={"500"} mt={1}>12 Nov 2024</Typography>
                    </Box>
                    <Box minWidth={"184px"} width={"17%"} margin={{ xs: "0 0 24px", sm: "" }}>
                        <Typography variant="body2" color="#333333">Next Billing Amount</Typography>
                        <Typography variant="subtitle1" color="initial" fontSize={"18px"} fontWeight={"500"} mt={1}>$220</Typography>
                    </Box>
                </Box>
            </Paper>
            <Paper sx={{
                p: "24px", mt: "39px", borderRadius: "8px",
                border: "1px solid #E8EAF0", boxShadow: "none"
            }}>
                <Typography variant="h5" color="initial" fontWeight={"500"} mb={1} > Plan Usage</Typography>
                <Box flexWrap={"wrap"}>
                    <Grid container columnSpacing={{ xs: 3, sm: 4, md: 4, lg: 4 }}>
                        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }} display={"flex"} alignItems={"center"} pb={{ xs: "32px", md: "48px" }} pt={{ xs: "24px", md: "48px" }}>
                            <Box width={"100%"}>
                                <Box display={"flex"} justifyContent={"space-between"}><Typography color='#333333' fontSize='12px' mb='4px' textAlign='left'>Participants</Typography><Typography color='#333333' fontSize='12px' mb='6px' textAlign='left'>40 of 100 (40% used)</Typography></Box>
                                <BorderLinearProgressGreen variant="determinate" value={70} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }} display={"flex"} alignItems={"center"} pb={{ xs: "42px", md: "48px" }} pt={{ xs: "24px", md: "48px" }}>
                            <Box width={"100%"}>
                                <Box display={"flex"} justifyContent={"space-between"}><Typography color='#333333' fontSize='12px' mb='4px' textAlign='left'>Live Attendees</Typography><Typography color='#333333' fontSize='12px' mb='6px' textAlign='left'>40 of 200 (20% used)</Typography></Box>
                                <BorderLinearProgressGreen variant="determinate" value={70} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 10, lg: 4, xl: 4 }}>
                            <Box className="storage-box-con" p={{ sx: "0 0 20px", xl: "0 20px 20px" }} display={"flex"} alignItems="end" justifyContent="center">
                                <Box className="storage-box" sx={{ position: 'relative' }} height={"100%"} maxHeight="142px" width={"100%"} maxWidth={"142px"} mr="36px">
                                    <CircularProgress variant="determinate" value={25} size={"100%"} color='primary' sx={(theme) => ({
                                        color: '#614EFA',
                                        animationDuration: '550ms',
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        zIndex: 1,
                                        [`& .${circularProgressClasses.circle}`]: {
                                            strokeLinecap: 'round',
                                            color: "#22B060",
                                        },
                                        ...theme.applyStyles('dark', {
                                            color: '#308fe8',
                                        }),
                                    })} />
                                    <CircularProgress variant="determinate" value={100} size={"100%"} color='primary' sx={(theme) => ({
                                        color: '#E8E8EA',
                                        animationDuration: '550ms',
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        [`& .${circularProgressClasses.circle}`]: {
                                            strokeLinecap: 'round',
                                            color: "#E8E8EA",
                                        },
                                        ...theme.applyStyles('dark', {
                                            color: '#E8E8EA',
                                        }),
                                    })} />
                                    <Box
                                        sx={{
                                            top: 0,
                                            left: 0,
                                            bottom: 0,
                                            right: 0,
                                            position: 'absolute',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',

                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            component="div"
                                            sx={{
                                                color: '#333333',
                                                fontSize: '18px',
                                                fontWeight: "500"
                                            }}
                                        >32% Used</Typography>
                                    </Box>
                                </Box>
                                <Box>
                                    <Typography variant="h5" color="#000000" fontWeight={"500"} mb={"21px"} >Storage</Typography>
                                    <Box display={"flex"} alignItems="center" mb={2}>
                                        <Box className="small-cirle" bgcolor={"#E8E8EA"} borderRadius={"100%"} height={"15px"} width={"15px"} mr={2}></Box>
                                        <Typography variant="subtitle1" color="#000000" fontSize={{ sm: "14px", md: "16px" }}>50GB Total</Typography>
                                    </Box>
                                    <Box display={"flex"} alignItems="center">
                                        <Box className="small-cirle" bgcolor={"#22B060"} borderRadius={"100%"} height={"15px"} width={"15px"} mr={2}></Box>
                                        <Typography variant="subtitle1" color="#000000" >25 GB Used</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper >

            {/* ===================subscribed add ons ================ */}
            <Paper sx={{
                p: "24px", mt: "39px", borderRadius: "8px",
                border: "1px solid #E8EAF0", boxShadow: "none"
            }}>
                <Typography variant="h5" color="initial" fontWeight={"500"} mb={3} >Subscribed Add-Ons</Typography>
                <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
                    <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                        <Card sx={{ padding: '26px 23px', border: '1px solid #A3A3A3', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', position: 'relative', height: '100%', borderRadius: "8px" }}>
                            <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                <Box>
                                    <Box display="flex" alignItems="center">
                                        <GroupIcon></GroupIcon>
                                        <Typography fontWeight='500' color='#333333' fontSize={{ xs: 'calc(15px + 5 * (100vw - 400px) / (1920 - 400))' }} ml="12px" >Additional Leads and Live Attendees</Typography>
                                    </Box>
                                    <Box display="flex" alignItems="start" mt='12px' justifyContent="space-between">
                                        <Typography color='#666666' fontSize='min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)' mt='4px'>100 additional leads and Live Attendees</Typography>
                                        <Typography color='#22B060' fontSize='min(calc(24px + 10 * (100vw - 400px) / (1920 - 400)), 34px)' fontWeight='500' ml="8px">$70</Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center">
                                        <Typography color='#333333' fontSize='min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)'>Renews on January 24, 2025</Typography>
                                        {/* <Box ml="12px" sx={{ cursor: "pointer" }}>
                                            {renewelPaused ? <BootstrapTooltip title="Pause Auto renewel"><Box display="flex" sx={{
                                                "&:hover svg": {
                                                    "path": {
                                                        fill: "#333333"
                                                    },
                                                    "rect": {
                                                        stroke: "#333333"
                                                    }
                                                }
                                            }} onClick={() => setRenewelPaused(false)}><PauseIcon /></Box></BootstrapTooltip> : <BootstrapTooltip title="Start Auto Renewel"><Box display="flex" sx={{
                                                "&:hover svg": {
                                                    "path": {
                                                        fill: "#E44258"
                                                    },
                                                    "rect": {
                                                        stroke: "#E44258"
                                                    }
                                                }
                                            }} onClick={() => setRenewelPaused(true)}><PlayIcon /></Box></BootstrapTooltip>}
                                        </Box> */}
                                    </Box>
                                    <Box mt="12px">
                                        <Box mb='12px'>
                                            <Box display={"flex"} justifyContent={"space-between"}><Typography color='#333333' fontSize='12px' mb='4px' textAlign='left'>Leads</Typography><Typography color='#333333' fontSize='12px' mb='6px' textAlign='left'>40 of 100 (40% used)</Typography></Box>
                                            <BorderLinearProgressGreen variant="determinate" value={70} />
                                        </Box>
                                        <Box>
                                            <Box display={"flex"} justifyContent={"space-between"}><Typography color='#333333' fontSize='12px' mb='4px' textAlign='left'>Live Attendees</Typography><Typography color='#333333' fontSize='12px' mb='6px' textAlign='left'>40 of 100 (40% used)</Typography></Box>
                                            <BorderLinearProgressGreen variant="determinate" value={30} />
                                        </Box>
                                    </Box>
                                    <Box display="flex" justifyContent="end">
                                        <Button variant="outlined" color="error" sx={{ height: "24px", mt: "12px", fontSize: "12px", px: "12px", borderRadius: "4px", textTransform: "capitalize" }} onClick={() => setCancelModal(true)}>
                                            Cancel
                                        </Button>
                                        <CancelSubscription
                                            open={isCancelModalOpen}
                                            onClose={handleCancelClose}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                        <Card sx={{ padding: '26px 23px', border: '1px solid #A3A3A3', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', position: 'relative', height: '100%', borderRadius: "8px" }}>
                            <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                <Box display="flex" alignItems="center">
                                    <CommunicationIcon></CommunicationIcon>
                                    <Typography fontWeight='500' color='#333333' fontSize={{ xs: 'calc(15px + 5 * (100vw - 400px) / (1920 - 400))' }} ml="12px" >Additional Co Hosts</Typography>
                                </Box>
                                <Box display="flex" alignItems="start" mt='12px' justifyContent="space-between">
                                    <Typography color='#666666' fontSize='min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)' mt='4px'>Renews on January 24, 2025</Typography>
                                    <Typography color='#22B060' fontSize='min(calc(24px + 10 * (100vw - 400px) / (1920 - 400)), 34px)' fontWeight='500' ml="8px">$70</Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography color='#333333' fontSize='min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)'>1 additional Co host</Typography>
                                    {/* <Box ml="12px" sx={{ cursor: "pointer" }}>
                                        {renewelPaused ? <BootstrapTooltip title="Pause Auto renewel"><Box display="flex" sx={{
                                            "&:hover svg": {
                                                "path": {
                                                    fill: "#333333"
                                                },
                                                "rect": {
                                                    stroke: "#333333"
                                                }
                                            }
                                        }} onClick={() => setRenewelPaused(false)}><PauseIcon /></Box></BootstrapTooltip> : <BootstrapTooltip title="Start Auto Renewel"><Box display="flex" sx={{
                                            "&:hover svg": {
                                                "path": {
                                                    fill: "#E44258"
                                                },
                                                "rect": {
                                                    stroke: "#E44258"
                                                }
                                            }
                                        }} onClick={() => setRenewelPaused(true)}><PlayIcon /></Box></BootstrapTooltip>}
                                    </Box> */}
                                </Box>
                                <Box display="flex" justifyContent="end" mt="auto">
                                    <Button variant="outlined" color="error" sx={{ height: "24px", mt: "12px", fontSize: "12px", px: "12px", borderRadius: "4px", textTransform: "capitalize" }} onClick={() => setCancelModal(true)}>
                                        Cancel
                                    </Button>
                                    <CancelSubscription
                                        open={isCancelModalOpen}
                                        onClose={handleCancelClose}

                                    />
                                </Box>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                        <Card sx={{ padding: '26px 23px', border: '1px solid #A3A3A3', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', position: 'relative', height: '100%', borderRadius: "8px" }} raised={false}>
                            <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                <Box display="flex" alignItems="center">
                                    <DatabaseIcon></DatabaseIcon>
                                    <Typography fontWeight='500' color='#333333' fontSize={{ xs: 'min(calc(15px + 5 * (100vw - 400px) / (1920 - 400)), 20px)' }} ml="12px" >Additional Storage</Typography>
                                </Box>
                                <Box display="flex" alignItems="start" mt='12px' justifyContent="space-between">
                                    <Typography color='#666666' fontSize='min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)' mt='4px'>Renews on January 24, 2025</Typography>
                                    <Typography color='#22B060' fontSize='min(calc(24px + 10 * (100vw - 400px) / (1920 - 400)), 34px)' fontWeight='500' ml="8px">$70</Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography color='#333333' fontSize='min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)'>50GB additional Storage</Typography>
                                    {/* <Box ml="12px" sx={{ cursor: "pointer" }}>
                                        {renewelPaused ? <BootstrapTooltip title="Pause Auto renewel"><Box display="flex" sx={{
                                            "&:hover svg": {
                                                "path": {
                                                    fill: "#333333"
                                                },
                                                "rect": {
                                                    stroke: "#333333"
                                                }
                                            }
                                        }} onClick={() => setRenewelPaused(false)}><PauseIcon /></Box></BootstrapTooltip> : <BootstrapTooltip title="Start Auto Renewel"><Box display="flex" sx={{
                                            "&:hover svg": {
                                                "path": {
                                                    fill: "#E44258"
                                                },
                                                "rect": {
                                                    stroke: "#E44258"
                                                }
                                            }
                                        }} onClick={() => setRenewelPaused(true)}><PlayIcon /></Box></BootstrapTooltip>}
                                    </Box> */}
                                </Box>
                                <Box display="flex" justifyContent="end" mt="auto">
                                    <Button variant="outlined" color="error" sx={{ height: "24px", mt: "12px", fontSize: "12px", px: "12px", borderRadius: "4px", textTransform: "capitalize" }} onClick={() => setCancelModal(true)}>
                                        Cancel
                                    </Button>
                                    <CancelSubscription
                                            open={isCancelModalOpen}
                                            onClose={handleCancelClose}                                    
                                        />
                                </Box>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Paper>
            {/* ===================subscribed add ons ================ */}

            {/* ===================go-to-market=============================== */}

            <Box className="billing-wrapper question-box" sx={{ borderRadius: '8px', marginTop: "42px" }} >
                <Box className="heading-text" sx={{ marginBottom: '16px' }}></Box>
                <Box className="billing-content ew-plan-question" sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Box className="ew-question-info">
                        <Typography variant="h5" gutterBottom>
                            Host Effortless Webinars With <Typography variant='h5' component="span" sx={{ fontWeight: 700 }}>Go-To-Market Solutions</Typography>
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            From Setup to Promotion – We Handle It All, So You Can Focus on Growing Your Business
                        </Typography>
                        <Button sx={{
                            background: "#FFF",
                            color: "#000",
                            borderRadius: "4px",
                            fontSize: "14px",
                            fontWeight: 500,
                            textAlign: "center",
                            padding: "0 12px",
                            marginTop: "15px",
                            border: "1px solid rgba(0, 0, 0, 0.4)",
                            height: "fit-content",
                            lineHeight: "169%",
                            minHeight: "44px",
                            display: "flex",
                            alignItems: "center",
                            width: "fit-content",
                            textTransform: "capitalize",
                            "&:hover": {
                                backgroundColor: "transparent",
                                color: "#ffffff",
                                borderColor: "#ffffff"
                            }


                        }} variant="outlined">Experience Ease with Go-To-Market Solutions</Button>
                    </Box>
                    <Box className="ew-question-img">
                        <img src={girlWithLaptop} alt="working-girl" style={{ width: '100%' }} />
                    </Box>
                </Box>
            </Box>
            {/* ===================go-to-market=============================== */}

            {/* ==================pricing table ================= */}
            <Box className="container ew-plan-boxes-con" mt="42px">
                <Box display="flex" justifyContent="space-between" width="100%" flexWrap="wrap" mb={3} gap={2}>
                    <Typography variant="h5" color="initial" fontWeight={"500"} >Upgrade Plan</Typography>
                    <FormGroup>
                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                            <Typography color='#22B060' fontWeight="500">Monthly</Typography>
                            <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
                            <Typography display="flex" alignItems="center" gap={1}>Annual <Typography component="span" color="#2B2B30" fontSize="12px">(2 Months Free)</Typography></Typography>
                        </Stack>
                    </FormGroup>
                </Box>
                <div className="ew-four-plans">
                    <div className="box">
                        <div>
                            <h3>Standard</h3>
                            <div className="ew-price-info price-info-monthly ew-show">
                                <Typography component="p" color='#000000'>$99</Typography>
                                <span>
                                    Per Host <br />
                                    <span>Billed Monthly</span>
                                </span>
                            </div>
                            {/* <div className="ew-price-info price-info-yearly ew-hide">
                                <p className="text-dark">$999</p>
                                <span>
                                    Per Host <br />
                                    <span>Billed Annually</span>
                                </span>
                            </div> */}
                            <h6 className="subtitle">500 leads + up to 100 live attendees</h6>

                            {/* <button
                                className="buy-yearly pro-btn ew-hide standard-btn"
                                onClick={() => console.log("Yearly plan selected")}
                            >
                                Buy Now
                            </button> */}
                            <button
                                className="buy-monthly pro-btn ew-show standard-btn"
                                onClick={() => console.log("Monthly plan selected")}
                            >
                                Buy Now
                            </button>
                            <a
                                href="https://easywebinar.com/terms-conditions#for-exceed-limit"
                                className="overages-may-link"
                            >
                                * Overages may apply.
                            </a>
                            <div className="ew-features-listing">
                                <h4>Features</h4>
                                <ul>
                                    <li>Up to 4 hours/webinar</li>
                                    <li>
                                        <span>
                                            3 active automated webinars
                                            <BootstrapTooltip
                                                title="Run recorded webinars in one timezone (without live chat feature)"
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>Unlimited live webinar sessions</li>
                                    <li>
                                        <span>
                                            Standard support
                                            <BootstrapTooltip
                                                title="Email and live chat support"
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>Up to 4 co-hosts</li>
                                    <li>Embeddable registration</li>
                                    <li>Custom registration fields</li>
                                    <li>Selected subscription add-ons</li>
                                    <li>Clone Webinar</li>
                                </ul>
                            </div>
                        </div>
                        <a href="#tbl_scrollable">
                            <div className="footer-sec">
                            </div>
                        </a>
                    </div>


                    {/* <!-- remove this className (black-friday-sales-className) when blackfriday changes are removed --> */}
                    <div className="box">
                        <div>
                            <h3>
                                Pro <span className="popular">
                                    <img src={mostPopular} alt="most popular" />
                                </span>
                            </h3>
                            <div className="ew-price-info price-info-monthly ew-show">
                                <Typography component="p" color='#22B060'>$197</Typography>
                                <span>
                                    Per Host <br />
                                    <span>Billed Monthly</span>
                                </span>
                            </div>

                            {/* <div className="ew-price-info price-info-yearly ew-hide">
                                <p className="text-primary-green">$89</p>
                                <span>
                                    Per Host <br />
                                    <span>Billed Annually</span>
                                </span>
                            </div> */}
                            <h6 className="subtitle third-card-heading">
                                2000 leads + up to 500 live attendees
                            </h6>

                            {/* <button
                                className="pro-btn pro-btn-bg buy-yearly ew-hide"
                                onClick={() => console.log("Yearly Plan Selected")}
                            >
                                Buy Now
                            </button> */}
                            <button
                                className="pro-btn pro-btn-bg buy-monthly ew-show"
                                onClick={() => console.log("Monthly Plan Selected")}
                            >
                                Buy Now
                            </button>
                            <a
                                href="https://easywebinar.com/terms-conditions#for-exceed-limit"
                                className="overages-may-link"
                            >
                                * Overages may apply.
                            </a>

                            <div className="ew-features-listing">
                                <h4>All Standard Features Plus</h4>
                                <ul>
                                    <li>Up to 8 hours/webinar</li>
                                    <li>10 active simulated live webinars</li>
                                    <li>Evergreen webinars</li>
                                    <li>Just-In-Time webinars</li>
                                    <li>Dedicated support</li>
                                    <li>Adaptability in the number of co-hosts</li>
                                    <li>Instant On-Demand (VSL events)</li>
                                    <li>Access to EW learning</li>
                                    <li>Custom UTM codes</li>
                                    <li>Custom integrations</li>
                                    <li>White labeling (add-on)</li>
                                    <li>C-Name (add-on)</li>
                                    <li>
                                        One-Time-Setup (add-on)
                                    </li>
                                    <li>Multiple subscription add-ons</li>
                                </ul>
                            </div>
                        </div>
                        <a href="#tbl_scrollable">
                            <div className="footer-sec">
                            </div>
                        </a>
                    </div>


                    <div className="box">
                        <div>
                            <h3>Enterprise</h3>
                            <div className="ew-price-info">
                                <span className="quote-note text-purple">Get a custom quote</span>
                            </div>
                            <h6 className="subtitle">Up to 500,000 live attendees</h6>
                            <button className="pro-btn" >
                                Contact Sales
                            </button>
                            <a
                                href="https://easywebinar.com/terms-conditions#for-exceed-limit"
                                className="overages-may-link"
                            >
                                * Overages may apply.
                            </a>
                            <div className="ew-features-listing">
                                <h4>All Pro Features Plus</h4>
                                <ul>
                                    <li>Up to 12 hours/webinar</li>
                                    <li>
                                        <span>
                                            10+ active simulated live/evergreen webinars
                                            <BootstrapTooltip
                                                title="Run recorded webinars in one time zone (live chat-add on)"
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Dedicated support & SLA
                                            <BootstrapTooltip
                                                title="Dedicated support, a robust SLA, seamless webinars with personalized assistance, guaranteed uptime, priority access to new features, and four training sessions for comprehensive skill development."
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Dedicated account manager
                                            <BootstrapTooltip
                                                title="An Account Manager holds your hand during your webinar build out and onboarding and can even come in to do the work for you at the lowest rate possible."
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>Up to 6 co-hosts</li>
                                    <li>
                                        <span>
                                            Personalized page builder
                                            <BootstrapTooltip
                                                title="Utilize our Personalized Page Builder to create webinar landing pages tailored to your exact specifications. Each page will be meticulously designed according to your specific requests."
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Premium landing page templates
                                            <BootstrapTooltip
                                                title="Pick a premium webinar landing page template and personalize it to align with your brand identity."
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Live event monitoring
                                            <BootstrapTooltip
                                                title="Incorporate live event monitoring as an add-on, with a dedicated member of EasyWebinar's expert support team attending your live webinars."
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>1-on-1 Onboarding + training</li>
                                    <li>
                                        <span>
                                            Enterprise & Custom Integrations
                                            <BootstrapTooltip
                                                title="Tailor your package with a custom integration of your choice."
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Access to API
                                            <BootstrapTooltip
                                                title="With EasyWebinar's API, you have the capability to develop robust applications seamlessly integrating live, interactive features."
                                            >
                                                <Box><InformationIcon /></Box>
                                            </BootstrapTooltip>
                                        </span>
                                    </li>
                                    <li>White label URLs and pages</li>
                                    <li>
                                        Webinar marketing services
                                    </li>
                                    <li>
                                        Done-For-You services <br />
                                        (add-on)
                                    </li>
                                    <li>Free One-Time setup</li>
                                </ul>
                            </div>
                        </div>
                        <a href="#tbl_scrollable">
                            <div className="footer-sec">
                            </div>
                        </a>
                    </div>
                </div>
            </Box>
            {/* ==================pricing table ================= */}


            {/* ===================available add ons ================ */}
            <Box mt="42px">
                <Typography variant="h5" color="#333333" fontWeight="500" mb="24px">Available Add Ons</Typography>
                <Box display="flex" gap="20px" flexWrap="wrap">
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },

                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="center">
                                    <img src={personAdd} />
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >Add-on Accounts</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">Enhance your capabilities at a lower cost with this exclusive add-on. Instead of adding a co-host, opt for another account seamlessly linked to your main one, offering the same number of leads/month and live attendees at a 30% discount.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">

                                <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">30%<Typography color="#333333" fontSize="14px" ml="4px" mb="2px">discount per/ account</Typography></Typography>


                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },
                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="center">
                                    <img src={humanResource} />
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >Additional Leads and Live attendees</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">An additional 1000 leads per month, along with 100 more live webinar attendees.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">

                                <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">78%<Typography color="#333333" fontSize="14px" ml="4px" mb="2px">/month</Typography></Typography>


                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },
                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="center">
                                    <img src={communication} />
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >Additional Co Hosts</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">Empower your team by adding them as co-hosts/presenters, enhancing management capabilities during webinars using your main account features.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">

                                <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$78<Typography color="#333333" fontSize="14px" ml="4px" mb="2px">/month</Typography></Typography>


                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },
                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="center">
                                    <img src={hubspot} />
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >Hubspot Integration</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">Connect HubSpot with your systems to optimize marketing, sales, and customer service through streamlined data and automation.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">

                                <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$99<Typography color="#333333" fontSize="14px" ml="4px" mb="2px">/ month</Typography></Typography>
                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>
                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },
                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="center">
                                    <img src={salesForceImg} />
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >Salesforce/Pardot Integration</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">Seamlessly integrate Salesforce and Pardot to boost your marketing automation and sales efficiency with unified data and real-time insights.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">
                                <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$99<Typography color="#333333" fontSize="14px" ml="4px" mb="2px">/ month</Typography></Typography>
                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },
                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="center">
                                    <img src={file} />
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >C-Name</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">Personalize your webinar experience with a custom domain that reflects your brand's identity.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">
                                <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$49<Typography color="#333333" fontSize="14px" ml="4px" mb="2px">/ month</Typography></Typography>
                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>
                            </Box>
                        </Box>
                    </Paper>
                </Box>
            </Box>
            {/* ===================available add ons ================ */}


            {/* ===================available go-to market Solutions ================ */}
            <Box mt="42px">
                <Typography variant="h5" color="#333333" fontWeight="500" mb="24px">Available Go-to Market Solutions</Typography>
                <Box display="flex" gap="20px" flexWrap="wrap">
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },

                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="end">
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >Webinar Setup + Live webinar monitoring</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">Optimize your EasyWebinar experience with our tailored setup service for a faster, more professional launch. Benefit from efficiency, expertise, and strategic guidance for superior webinar success. Launch better webinars effortlessly.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">
                                <Box display="flex" alignItems="baseline">
                                    <Typography color="#333333" fontSize="14px" mr="4px">starts from</Typography>
                                    <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$250</Typography>
                                </Box>
                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },

                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="end">
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >End to End Launch</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">We create stunning landing pages, lead forms, and graphics for a professional and impactful online presence, regardless of your industry.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">
                                <Box display="flex" alignItems="baseline">
                                    <Typography color="#333333" fontSize="14px" mr="4px">starts from</Typography>
                                    <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$75</Typography>
                                </Box>
                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },

                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="end">
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >Marketing/Promotion</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">EasyWebinar enhances your webinar impact with tailored digital marketing. From engaging landing pages to compelling content, we ensure attention and effective lead generation.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">
                                <Box display="flex" alignItems="baseline">
                                    <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$70</Typography>
                                </Box>
                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },

                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="end">
                                    <Typography fontSize="18px" fontWeight="500" color="#333333">Setup Emails</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">EasyWebinar streamlines your communication with pre-, during-, and post-webinar email automations. Seamlessly integrate signup forms with your email marketing platform and deploy thank-you pages designed to drive desired actions.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">
                                <Box display="flex" alignItems="baseline">

                                    <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$99</Typography>
                                    <Typography color="#333333" fontSize="14px" mr="4px">/month</Typography>
                                </Box>
                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{
                        maxWidth: "387px",
                        width: "100%",
                        minHeight: "280px",
                        p: "24px 15px", borderRadius: "8px",
                        border: "1px solid #E8EAF0", boxShadow: "none",
                        '@media (min-width:768px) and (max-width:1366px)': {
                            width: "47%",
                        },
                        '@media (min-width:320px) and (max-width:600px)': {
                            maxWidth: "100%",
                        },

                    }}>
                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                            <Box mb="24px">
                                <Box mb="24px" display="flex" gap="18px" alignItems="end">
                                    <Typography fontSize="18px" fontWeight="500" color="#333333" >Evergreen Funnels</Typography>
                                </Box>
                                <Typography color="#333333" fontSize="14px" lineHeight="24px">Our service includes strategically designed sales funnels to guide your audience toward key actions, ensuring seamless transitions from engagement to conversion.</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="16px">
                                <Box display="flex" alignItems="baseline">
                                    <Typography display="flex" alignItems="end" fontSize="20px" color="#22B060" fontWeight="600">$250</Typography>
                                </Box>
                                <Button variant='outlined' sx={{ textTransform: "capitalize", border: "1px solid #333333", color: "#333333", borderRadius: "4px", px: "12px", height: "32px" }}>Add to Plan</Button>

                            </Box>
                        </Box>
                    </Paper>
                </Box>

            </Box>
            {/* ===================available go-to market Solutions ================ */}

            {/* ===================footer-section ================ */}
            <Box display="flex" justifyContent="flex-end" alignItems="center" mt={{ xs: "25px", sm: "42px" }}>
                <Typography color="#666666" fontSize="14px">Got a question? Get in touch with our Support Team<a href="#" style={{ color: "#178EFC", marginLeft: "4px", textDecoration: "none" }}>Support Team</a></Typography>
                <Button variant="outlined" color="error" sx={{ textTransform: "capitalize", marginLeft: "35px" }} onClick={() => setModalOpen(true)}>Cancel Account</Button>
                <CancelAccountModal
                    open={isModalOpen}
                    onClose={handleClose}
                //  forSecondTimeUser={false} 
                />
            </Box>
            {/* ===================footer-section ================ */}

        </Container >
    )
}

export default SubscriptionDetails